import { TableRow as MuiTableRow } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TableRow = styled(MuiTableRow)(() => ({
  height: '50px',
}));
